import { Button } from "antd";
import React, { useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  FeatureGroup,
  GeoJSON,
  Polygon,
  Pane,
} from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "react-lottie";
import * as worldAnimation from "../../../../animations/69023-world-map-blue.json";
import L, { divIcon, icon, latLng } from "leaflet";

import {
  layerFetch,
  selectLicenseList,
  setCurrentPotential,
  setPotentialModal,
  setSliderStatus,
} from "../../api/redux";
import Markers from "./Markers";
import Control from "react-leaflet-custom-control";
import MarkerClusterGroup from "react-leaflet-markercluster";
import PotentialModal from "./PotentialModal";
import config from "../../../../config/config";
import { getGeoApifyDetails } from "../../api/crud";
import { EditControl } from "react-leaflet-draw";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: worldAnimation.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default () => {
  const [currentGeoApify, setCurrentGeoApify] = useState(null);
  const state = useSelector(selectLicenseList);
  const dispatch = useDispatch();

  const styleSetter = (data) => {
    return {
      color: data.properties.color || "blue",
      fillOpacity: "60%",
      weight: 3,
      opacity: 1,
      zIndex: 1,
    };
  };

  const markerGenerator = (iconUrl) => {
    return new L.circleMarker({
      className: "",
      iconAnchor: [12, 25],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -15],
      iconUrl,
    });
  };

  const createClusterCustomIcon = function (cluster, name) {
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: "marker-cluster-custom",
      iconSize: L.point(40, 40, true),
    });
  };

  console.log("mapAttrs", state?.mapAttr);

  return (
    <>
      {state.layerDetailsLoaded && state.isMapAttrsReady && state.province ? (
        <MapContainer
          maxZoom={15}
          bounds={
            state.province.spanData.type === "MultiPolygon"
              ? state.province?.spanData?.coordinates[0][0].map((el) => {
                  return [el[1], el[0]];
                })
              : state.province?.spanData?.coordinates[0].map((el) => {
                  return [el[1], el[0]];
                })
          }
        >
          {state?.mapAttr && (
            <TileLayer
              attribution={state?.mapAttr?.attr}
              url={state?.mapAttr?.url}
              key={1}
            />
          )}
          <Control position="topleft">
            <Button
              style={{ width: "1rem" }}
              className="border border-white border-8 d-flex align-items-center justify-content-center"
              onClick={() => {
                dispatch(setSliderStatus(true));
              }}
            >
              <i className="fa fa-search" />
            </Button>
          </Control>
          <Control position={state.isSliderOpen ? "topleft" : "topright"}>
            {" "}
            {state.layersColor.length !== 0 &&
              state.layersColor &&
              state.layersColor.map((el) => {
                return (
                  <div
                    className="bg-white d-flex flex-column p-2"
                    style={{
                      gap: "5px",
                      minWidth: "5rem",
                      width: "auto",
                      minHeight: "3rem",
                      height: "auto",
                    }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "5px" }}
                    >
                      {el.color && (
                        <div className="d-flex" style={{ gap: "5px" }}>
                          رنگ لایه {el.title}:
                          <div
                            style={{
                              backgroundColor: `${el.color}`,
                              borderRadius: "6px",
                              width: "25px",
                              height: "25px",
                              opacity: "0.4",
                              border: `2px solid ${el.color}`,
                            }}
                          ></div>
                        </div>
                      )}
                      {el.marker && (
                        <>
                          {" "}
                          <span>-</span>
                          <div className="d-flex" style={{ gap: "5px" }}>
                            آیکون {el.title}:{" "}
                            <img src={el.marker} style={{ width: "20px" }} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </Control>
          <FeatureGroup>
            <EditControl
              position="topright"
           
              edit={{ edit: false }}
         
              draw={{
                rectangle: false,
                circle: false,
                circlemarker: false,
                marker: false,
                polygon: false,
                polyline: true,
              }}
            />
            {state.layerDetails &&
              state.layerDetails.map((el, idx) => {
                const option = {};
                if (el.marker) {
                  option.pointToLayer = (e, a) => {
                    if (el.marker) {
                      var LeafIcon = L.Icon.extend({
                        options: {
                          iconSize: [15, 25],
                          iconAnchor: [12, 50],
                        },
                      });
                      let greenIcon = new LeafIcon({
                        iconUrl: el.marker,
                      });
                      return L.marker([a?.lat, a?.lng], {
                        icon: greenIcon,
                      });
                    }
                  };
                }
                return (
                  <GeoJSON
                    eventHandlers={{
                      click: (e) => {
                        setCurrentGeoApify(null);
                        const params = {
                          apiKey: config.geoApifyAccessToken,
                          format: "json",
                          lat: e?.latlng.lat,
                          lon: e?.latlng.lng,
                          lang: "fa",
                        };
                        getGeoApifyDetails(params).then((res) => {
                          setCurrentGeoApify(res.data.results[0]);
                        });
                      },
                    }}
                    key={`layer${idx}`}
                    data={el}
                    style={styleSetter}
                    {...option}
                  >
                    <Popup>
                      {currentGeoApify ? (
                        <div
                          className="p-2 d-flex flex-column text-right"
                          style={{ gap: "3px" }}
                        >
                          {currentGeoApify?.formatted && (
                            <div>
                              <span
                                style={{ color: "#6c6c6c", fontSize: "15px" }}
                              >
                                جزییات مکان
                              </span>
                              <br />
                              <h5 className="mt-1 lh-30">
                                {currentGeoApify.formatted}
                              </h5>
                            </div>
                          )}
                          {currentGeoApify?.district && (
                            <div>
                              <span
                                style={{ color: "#6c6c6c", fontSize: "15px" }}
                              >
                                ناحیه
                              </span>
                              <br />
                              <h6 className="mt-1 lh-30">
                                {currentGeoApify.district}
                              </h6>
                            </div>
                          )}
                          {currentGeoApify?.lat && currentGeoApify?.lon && (
                            <div>
                              <span
                                className="mb-2"
                                style={{ color: "#6c6c6c", fontSize: "15px" }}
                              >
                                اطلاعات جغرافیایی
                              </span>
                              <br />
                              <h6 className="mt-2 my-auto">
                                عرض جغرافیایی : {currentGeoApify.lat}
                              </h6>{" "}
                              <br />
                              <h6 className="my-auto mt-1">
                                طول جغرافیایی: {currentGeoApify.lon}
                              </h6>
                            </div>
                          )}
                        </div>
                      ) : (
                        <Lottie
                          options={defaultOptions}
                          height={"100%"}
                          width={"75%"}
                        />
                      )}
                    </Popup>
                  </GeoJSON>
                );
              })}

            {state.potentials &&
              config.isPotentialAvailable &&
              state.potentials.map((el) => {
                const option = {};
                if (el?.Sector.marker) {
                  let iconUrl = el.Sector.marker;
                  const iconUrlCondition =
                    iconUrl &&
                    `http://atlas-kerman.arian.co.ir${
                      iconUrl[iconUrl.length - 1] === "/"
                        ? iconUrl.substring(0, iconUrl.length - 2)
                        : iconUrl
                    }`;

                  const leafletIcon = L.divIcon({
                    className: "custom-div-icon",
                    html: `<div style='background-color:#0879fa;' class='marker-pin'></div><img class="icon-img" src='${iconUrlCondition}' />`,
                    iconSize: [35, 55],
                    iconAnchor: [12, 50],
                  });

                  option.icon = leafletIcon;
                }
                return (
                  <Pane style={{ zIndex: 5999999999 }}>
                    {el.spanData && (
                      <GeoJSON
                        data={el?.spanData}
                        eventHandlers={{
                          click: async (e) => {
                            dispatch(setCurrentPotential(null));
                            setTimeout(() => {
                              dispatch(setCurrentPotential(el));
                              dispatch(setPotentialModal(true));
                            }, 200);
                          },
                        }}
                        style={{ color: "red", fillOpacity: "60%", weight: 4 }}
                      />
                    )}
                    {el?.point?.coordinates && (
                      <Marker
                        {...option}
                        position={el?.point.coordinates}
                        eventHandlers={{
                          click: async (e) => {
                            dispatch(setCurrentPotential(null));
                            setTimeout(() => {
                              dispatch(setCurrentPotential(el));
                              dispatch(setPotentialModal(true));
                            }, 200);
                          },
                        }}
                      ></Marker>
                    )}
                  </Pane>
                );
              })}

            {state.province && <GeoJSON data={state.province?.spanData} />}

            <MarkerClusterGroup>
              <Markers />
            </MarkerClusterGroup>
          </FeatureGroup>
        </MapContainer>
      ) : (
        <Lottie options={defaultOptions} height={"75%"} width={"50%"} />
      )}
      {state.currentPotential && <PotentialModal />}
    </>
  );
};
